import { Card } from "primereact/card";
import { classNames } from "primereact/utils";

/**
 * Wraps a DataTable in a consistent admin panel (no extra body padding).
 * @param {React.ReactNode} [header] — Optional toolbar/title row above the table.
 */
export function AdminTableShell({ header, children }) {
    const headerNode = header ? (
        <div className="flex align-items-center flex-wrap gap-2 px-3 py-2 surface-50 border-bottom-1 surface-border">
            {header}
        </div>
    ) : undefined;

    return (
        <Card
            {...(headerNode !== undefined ? { header: headerNode } : {})}
            className={classNames(
                "uc-admin-table-shell",
                "surface-card",
                "border-1",
                "surface-border",
                "border-round-xl",
                "shadow-2",
                "m-0",
            )}
            pt={{
                body: { className: classNames("p-0") },
                content: { className: classNames("p-0") },
                header: { className: classNames("p-0", "border-none") },
            }}
        >
            {children}
        </Card>
    );
}
